export default __webpack_public_path__ + "static/media/logo.ad8d75f2.svg";